<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          to="/add-colis"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
        >
          Nouveau Colis
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-sm-flex align-items-center">
        <form class="search-box position-relative" @submit.prevent="filterList">
          <input
            v-model="searchTerm"
            type="text"
            @input="filterList"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Chercher"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-scroll-outer">
        <div class="table-scroll-mobile">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Code d'envoi
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Dernière mise à jour
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Destinataire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Commentaire
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Ville
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Prix
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <th
                class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
              >
                <div class="d-flex align-items-center">
                  <h6 v-if="row.replace === 1" class="text-warning">
                    {{ row.code }}
                    <i class="ph ph-repeat"></i>
                  </h6>
                  <h6 v-else-if="row.partial === 1" class="text-info">
                    {{ row.code }}
                    <i class="ph ph-arrows-down-up"></i>
                  </h6>
                  <h6 v-else>
                    {{ row.code }}
                  </h6>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ getDate(row.updated_at) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <p class="text-nowrap">
                  <b>{{ row.receiver }}</b> <br />
                  <b>{{ oldPhone(row.phone) }}</b> <br />
                </p>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <p>{{ row.note }}</p>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': getBadgeConfig(row).color }"
                >
                  {{ getBadgeConfig(row).text }}
                  <template v-if="getBadgeConfig(row).date">
                    <br />{{ getBadgeConfig(row).date }}
                  </template>
                  <template v-if="getBadgeConfig(row).comment">
                    <br />{{ getBadgeConfig(row).comment }}
                  </template>
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.city_name }}</b>
                <!-- <br />
                <p v-if="row.quartier && row.quartier.name">
                  {{ row.quartier.name }}
                </p> -->
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.price }} </b>Dhs<br />
                <p style="word-wrap: break-word; width: 50%">
                  {{ row.product_nature }}
                </p>
              </td>

              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <!-- Infos -->
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetails(row)"
                      >
                        <i
                          class="flaticon-view lh-1 me-8 position-relative top-1"
                        ></i>
                        Détails
                      </button>
                    </li>
                    <!-- Conditional Delete -->
                    <li v-if="row.status === 'NEW_PARCEL'">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="Destroy_Coli(row)"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        Supprimer
                      </a>
                    </li>
                    <!-- Update -->
                    <li v-if="row.status == 'NEW_PARCEL'">
                      <router-link
                        :to="`/edit-colis/${row.id}/${row.code}`"
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </router-link>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
      >
        <p class="mb-0 text-paragraph">
          Showing
          <span class="fw-bold">
            {{ (filter.current_page - 1) * filter.per_page + 1 }}
          </span>
          –
          <span class="fw-bold">
            {{ Math.min(filter.current_page * filter.per_page, filter.total) }}
          </span>
          out of <span class="fw-bold">{{ filter.total }}</span> results
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="displayedPages[0] > 1" class="page-item">
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(1)"
                >1</a
              >
            </li>
            <li v-if="displayedPages[0] > 2" class="page-item disabled">
              <span class="page-link">...</span>
            </li>

            <li v-for="page in displayedPages" :key="page" class="page-item">
              <a
                href="javascript:void(0)"
                class="page-link"
                :class="{ active: filter.current_page === page }"
                @click="goToPage(page)"
              >
                {{ page }}
              </a>
            </li>

            <li
              v-if="
                displayedPages[displayedPages.length - 1] < filter.last_page - 1
              "
              class="page-item disabled"
            >
              <span class="page-link">...</span>
            </li>
            <li
              v-if="
                displayedPages[displayedPages.length - 1] < filter.last_page
              "
              class="page-item"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(filter.last_page)"
              >
                {{ filter.last_page }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Status details colios -->
  <div
    class="modal fade"
    id="modal_detail_colis"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Détails Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <DetailsColis
            v-if="coliDetails"
            :coliDetails="coliDetails"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { computed, onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import DetailsColis from "./DetailsColis.vue";

export default {
  name: "ColisList",
  components: {
    DetailsColis,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);

    const filter = reactive({
      surrent_page: 1,
      per_page: 10,

      searchTerm: "",
      total: 0,
      last_page: 1,
      current_page: 1,
    });

    const searchTerm = ref("");

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const status = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const zonesList = ref<Status[]>([]);
    const citiesList = ref<Status[]>([]);
    const livreurList = ref<Status[]>([]);
    const etatList = ref<Status[]>([]);

    function convert(date) {
      // example: to YYYY-MM-DD (adapt to your backend)
      const d = new Date(date);
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${m}-${day}`;
    }

    function getDate(value) {
      if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    function buildQuery() {
      const params = new URLSearchParams({
        searchTerm: filter.searchTerm || "",
        page: String(filter.current_page || 1),
        per_page: String(filter.per_page || 10),
      });
      return `/api/auth/client/colis_list?${params.toString()}`;
    }

    onMounted(async () => {
      flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
      });

      flatpickr("#basic-calendar", {
        dateFormat: "Y-m-d H:i",
      });
      getRecords();
      fetchStatus();
    });

    async function getRecords() {
      isLoader.value = true;
      try {
        const url = buildQuery();
        const { data } = await api.get(url);

        rows.value = data.users.data;

        // Keep your search fields; only update pagination/meta you need:
        filter.current_page = data.users.current_page;
        filter.per_page = data.users.per_page;
        filter.total = data.users.total;
        filter.last_page = data.users.last_page;

        // If you actually need all fields returned from backend:
        // Object.assign(users, { ...users, ...data.users })
      } finally {
        isLoader.value = false;
      }
    }

    function filterList() {
      filter.searchTerm = searchTerm.value || "";
      filter.current_page = 1;
      getRecords();
    }

    function removeFilter() {
      // reset users filters
      filter.searchTerm = "";
      filter.current_page = 1;

      searchTerm.value = "";
      getRecords();
    }

    async function fetchStatus() {
      try {
        const response = await api.get("/api/auth/AllStatus");
        if (response && response.data) {
          status.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    }

    function goToPage(page) {
      if (page < 1 || page > filter.last_page) return;
      filter.current_page = page;
      getRecords();
    }

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }
    function globalHelper(s: string) {
      if (!s || s === "undefined") {
        return null; // always return null for invalid values
      }
      return status.value.find((o) => o.code === s) || null;
    }

    function removeHours(value) {
      if (value && value !== "") {
        const datePart = value.split(" ")[0];
        return datePart;
      }
    }
    function reported(date) {
      const currentDate = new Date();
      const reportedDate = new Date(date);
      if (reportedDate.getTime() <= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    function resolveUserStatusVariant(status) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      if (status === "Payé") return "info";
      if (status === "Non Payé") return "warning";
      if (status === "Facturé") return "info";
      return "primary";
    }

    function getStatusName(code?: string) {
      return code ? globalHelper(code)?.name || "" : "";
    }

    function getStatusColor(code?: string) {
      return code ? globalHelper(code)?.code_color || "#000" : "#000";
    }

    function formatReported(row: any) {
      return removeHours(row.reported_date);
    }

    // Decide what to show in badge
    function getBadgeConfig(row: any) {
      // IN_PROGRESS with secondary status
      if (
        row.status === "IN_PROGRESS" &&
        row.status_second &&
        getStatusName(row.status_second)
      ) {
        if (
          ["POSTPONED", "PROGRAMED", "POSTPONED_TODAY"].includes(
            row.status_second
          )
        ) {
          return {
            text: getStatusName(row.status_second),
            date: formatReported(row),
            color: reported(row.reported_date)
              ? "#E50A0A"
              : getStatusColor(row.status_second),
          };
        }
        return {
          text: getStatusName(row.status_second),
          color: getStatusColor(row.status_second),
        };
      }

      // RETURNED but not REFUSE
      if (
        row.status === "RETURNED" &&
        (!row.status_second || row.status_second !== "REFUSE") &&
        row.last_statut_comment
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `${row.statut.s_name} Endommagé`
              : row.statut.s_name,
          comment: row.last_statut_comment,
          color: row.statut.code_color,
        };
      }

      // RETURNED with REFUSE
      if (
        row.status === "RETURNED" &&
        row.status_second === "REFUSE" &&
        getStatusName(row.status_second)
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `Retourné Endommagé - ${getStatusName(row.status_second)}`
              : `Retourné - ${getStatusName(row.status_second)}`,
          comment: row.last_statut_comment,
          color: getStatusColor(row.status_second),
        };
      }

      // Default
      return {
        text:
          row.rn_e && row.rn_e !== 0 && row.status === "RETURNED"
            ? `${row.statut.s_name} Endommagé`
            : row.statut.s_name,
        color: row.statut.code_color,
      };
    }

    let debounceTimeout: number | undefined;

    // function onSearchClients(search, loading) {
    //   clearTimeout(this.searchTimeout)
    //   this.searchTimeout = setTimeout(() => {
    //     this.filterClients(search, loading)
    //   }, 300) // Debounce time in milliseconds
    // },

    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    async function onSearchDrivers(
      search: string,
      loading: { value: boolean }
    ) {
      const query = search.trim().toLowerCase();

      if (!query) {
        livreurList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/LivsList`, {
            params: { query },
          });
          livreurList.value = res.data;
          livreurList.value.unshift({ code: "", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          livreurList.value = [];
        }
      }, 300); // 300ms debounce
    }

    const coliDetails = ref<any>({});
    const colisId = ref(null);
    const isOpen = ref(false);
    async function showDetails(row) {
      isOpen.value = false;
      coliDetails.value = row;

      console.log("Showing details for parcel:", coliDetails);
      const modalEl = document.getElementById("modal_detail_colis");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpen.value = true;
        modal.show();
      }
      // TODO: Open info modal
    }

    async function Destroy_Coli(row: any) {
      console.log("Deleting parcel:", row);
      Swal.fire({
        text: "Vous voulez supprimer ce colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          try {
            const res = await api.post(
              `/api/auth/client/DeleteColis/${row.id}`
            );
            if (res.data.message === "success") {
              showToast("Colis supprimé avec succès", "success");
              getRecords();
            } else if (res.data.message === "error") {
              showToast("Vous pouvez pas supprimer ce colis", "error");
            }
          } catch (error) {
            showToast("Erreur lors de la suppression du colis", "error");
          }
        }
      });
    }

    const displayedPages = computed(() => {
      const total = filter.last_page;
      const current = filter.current_page;
      const delta = 2; // Number of pages to show before and after current page

      let start = Math.max(1, current - delta);
      let end = Math.min(total, current + delta);

      // Adjust range if we are at the very beginning or end
      if (current <= delta) {
        end = Math.min(total, delta * 2 + 1);
      } else if (current > total - delta) {
        start = Math.max(1, total - delta * 2);
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    });

    return {
      auth,
      rows,
      goToPage,
      filter,
      getDate,
      oldPhone,
      globalHelper,
      removeHours,
      reported,
      resolveStatuParcel,
      resolveUserStatusVariant,
      getBadgeConfig,

      searchTerm,

      clientList,
      zonesList,
      citiesList,
      livreurList,
      etatList,
      status,

      filterClients,
      onSearchDrivers,
      filterList,
      removeFilter,

      coliDetails,
      isOpen,
      showDetails,
      Destroy_Coli,
      getRecords,
      displayedPages,
    };
  },
};
</script>
